let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iTZbT")).then(() => parcelRequire('3eMO2'));